import FeaturedProfilesCarousel from './FeaturedProfilesCarousel';
export default FeaturedProfilesCarousel;